(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[58866,53120],{

/***/ 632843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68706);
/* harmony import */ var _terra_js_web_bridge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(685172);


const ShopFrontKitLoadable = __webpack_require__.e(/* import() */ 22765).then(__webpack_require__.t.bind(__webpack_require__, 722765, 23));
const PaymentKitLoadable = __webpack_require__.e(/* import() */ 25098).then(__webpack_require__.bind(__webpack_require__, 225098));
const waitForPaymentStatus = "WAITING_FOR_PAYMENT_CONFIRMATION";
const terraHelper = {
    isAvailable: _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable,
    getLoyaltyConfig: ()=>{
        return _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].loyalty */ .Z.loyalty().getLoyaltyConfig();
    },
    handleBackOr: async (callback)=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const ShopFrontKit = (await ShopFrontKitLoadable).default;
            const shouldHandleBack = await ShopFrontKit.shouldHandleBack();
            if (shouldHandleBack) {
                ShopFrontKit.handleBack();
            } else {
                callback === null || callback === void 0 ? void 0 : callback();
            }
        } else {
            callback === null || callback === void 0 ? void 0 : callback();
        }
    },
    getScreenConfig: async ()=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const ShopFrontKit = (await ShopFrontKitLoadable).default;
            return ShopFrontKit.getScreenConfig();
        } else {
            return Promise.resolve(undefined);
        }
    },
    finish: ()=>_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].finish */ .Z.finish(),
    payForOrder: (param)=>{
        let { order , customerProfileId , orderService  } = param;
        return terraHelper.pay({
            orderCode: order.code,
            orderId: order.id,
            amount: order.remainPayment,
            customerProfileId,
            orderService
        });
    },
    pay: async (param)=>{
        let { orderCode , orderId , amount , customerProfileId , orderService  } = param;
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            const { default: PaymentKit , PaymentRequestBuilder  } = await PaymentKitLoadable;
            const paymentRequestBuilder = new PaymentRequestBuilder();
            const { MainMethodType  } = await __webpack_require__.e(/* import() */ 91621).then(__webpack_require__.bind(__webpack_require__, 891621));
            paymentRequestBuilder.setOrder({
                orderCode: orderCode,
                orderAmount: amount
            }).setPaymentMethods({
                mainMethod: {
                    method: MainMethodType.All,
                    amount
                },
                totalAmount: amount
            }).setOptions({
                shouldShowPaymentResultScreen: true
            });
            return PaymentKit.payForOrder(paymentRequestBuilder.build()).then((result)=>{
                switch(result.resultCode){
                    case "succeeded":
                        window.location.href = "/account/orders/".concat(orderId);
                        break;
                    case "canceled":
                    case "failed":
                        orderService.getOrder({
                            orderId,
                            customerId: customerProfileId
                        }).then((order)=>{
                            if (order.status === waitForPaymentStatus) {
                                window.location.href = "/confirm-payment/".concat(orderId);
                            } else {
                                window.location.href = "/account/orders?tab=WAIT_PAYMENT";
                            }
                        }).catch(()=>{
                            // this is a fallback in case the order is not synced with cov
                            window.location.href = "/account/orders?tab=WAIT_PAYMENT";
                        });
                        break;
                }
            });
        }
        return Promise.resolve();
    },
    observeOpenBuyNow: (params, handlers)=>{
        if (_terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].isAvailable */ .Z.isAvailable()) {
            _terra_js_terra_kit__WEBPACK_IMPORTED_MODULE_0__/* ["default"].common */ .Z.common().openBuyNow(params).subscribe(handlers);
        }
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (terraHelper);


/***/ }),

/***/ 162831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useTerraScreenConfig; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var helpers_terra__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(632843);


const useTerraScreenConfig = ()=>{
    const { 0: screenConfig , 1: setScreenConfig  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        (async ()=>{
            const config = await helpers_terra__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getScreenConfig */ .Z.getScreenConfig();
            setScreenConfig(config);
        })();
    }, []);
    return screenConfig;
};


/***/ }),

/***/ 233373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PbLayout": function() { return /* binding */ PbLayout; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-elements-virtual-6fb853c5ba/0/cache/@tempi-core-elements-npm-1.0.84-463903109d-926eaad9a7.zip/node_modules/@tempi/core-elements/dist/renderer.js
var renderer = __webpack_require__(214208);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-a77cab8a05/0/cache/@tempi-core-renderer-npm-1.0.84-b33353fd89-9079419dc9.zip/node_modules/@tempi/core-renderer/dist/utils/render.es.js
var render_es = __webpack_require__(832481);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-core-renderer-virtual-a77cab8a05/0/cache/@tempi-core-renderer-npm-1.0.84-b33353fd89-9079419dc9.zip/node_modules/@tempi/core-renderer/dist/render.es.js
var dist_render_es = __webpack_require__(804616);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-ecom-elements-virtual-94e4071fbd/0/cache/@tempi-ecom-elements-npm-1.0.84-1c112f128e-a6b1f8bb49.zip/node_modules/@tempi/ecom-elements/dist/renderer.js
var dist_renderer = __webpack_require__(904356);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
// EXTERNAL MODULE: ./helpers/env.ts
var env = __webpack_require__(353632);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./hooks/useTerraScreenConfig.ts
var useTerraScreenConfig = __webpack_require__(162831);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/swr-virtual-976cccc57b/0/cache/swr-npm-1.1.2-8ec1c9a7ac-84bf222c66.zip/node_modules/swr/dist/index.esm.js
var index_esm = __webpack_require__(859676);
// EXTERNAL MODULE: ./modules/page-builder/service.ts + 1 modules
var service = __webpack_require__(137697);
;// CONCATENATED MODULE: ./modules/page-builder/hooks/usePbLayout.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const usePbLayout = (param)=>{
    let { device , defaultValue  } = param;
    const { epicEcom480 , tempiWebsiteDomain  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { data , error , isValidating  } = (0,index_esm/* default */.ZP)([
        device
    ], async (device)=>{
        var ref, ref1;
        const builder = new service/* PbService */.N(epicEcom480 ? tempiWebsiteDomain || "" : (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.hostname) || "", window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.hostname, epicEcom480 || false);
        const { layoutConfig , menu , websiteId  } = await builder.getLayoutPage(device);
        return {
            layoutConfig,
            menu,
            websiteId
        };
    }, {
        fallbackData: defaultValue,
        revalidateOnFocus: false
    });
    return _objectSpreadProps(_objectSpread({}, data), {
        error,
        loading: isValidating
    });
};

// EXTERNAL MODULE: ./modules/page-builder/slots/index.ts
var slots = __webpack_require__(164821);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(85470);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./modules/page-builder/layout.tsx
function layout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function layout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            layout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  line-height: 1.5;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}












const BackButtonHeaderMobile = dynamic_default()(()=>__webpack_require__.e(/* import() */ 49124).then(__webpack_require__.bind(__webpack_require__, 749124)).then((f)=>f.BackButtonHeaderMobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(749124)
            ]
    }
});
const PbLayout = (param)=>{
    let { config: serverConfig , children , pageProps ,  } = param;
    var ref;
    const { isMobile , terminal , location , terminalId  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const device = isMobile ? "mobile" : "desktop";
    const router = (0,next_router.useRouter)();
    const { query  } = router;
    const page = usePbLayout({
        device,
        defaultValue: {
            layoutConfig: layout_objectSpread({}, serverConfig),
            menu: (pageProps === null || pageProps === void 0 ? void 0 : pageProps.menu) || []
        }
    });
    const { layoutConfig , menu , websiteId  } = page;
    const { partner , getProcessEnv  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const screenConfig = (0,useTerraScreenConfig/* useTerraScreenConfig */.a)();
    const backappUrl = getProcessEnv("BACKAPP_URL");
    const showBackButton = !(screenConfig === null || screenConfig === void 0 ? void 0 : (ref = screenConfig.header) === null || ref === void 0 ? void 0 : ref.isBackIconHidden) && (!!partner || !!backappUrl);
    const mappingDynamicMobileSlotsAddNew = layout_objectSpread({}, slots/* mappingDynamicMobileSlots */.Q, showBackButton ? {
        back_button_header_mobile: BackButtonHeaderMobile
    } : {});
    const mappingDynamicSlots = device === "mobile" ? mappingDynamicMobileSlotsAddNew : slots/* mappingDynamicDesktopSlots */.B;
    const componentDict = (0,react.useMemo)(()=>(0,render_es/* buildComponentDict */.Oq)(layout_objectSpread({}, renderer/* components */.w, dist_renderer/* components */.w)), []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        id: "tempi-layout",
        children: [
            (layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.header) && (!query.hideHeader || !query.supportOmniAppUI) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_render_es/* BuilderComponent */.V, {
                componentDict: componentDict,
                content: layoutConfig.header,
                configs: {
                    device,
                    env: (0,env/* getEnv */.dU)("LANDING_BUILDER_ENV"),
                    terminalCode: terminal,
                    terminalId,
                    locationCode: location,
                    mappingDynamicSlots,
                    globalData: {
                        menu,
                        websiteId
                    }
                },
                rootId: "HEADER"
            }),
            children,
            (layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.footer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_render_es/* BuilderComponent */.V, {
                componentDict: componentDict,
                content: layoutConfig.footer,
                configs: {
                    device,
                    env: (0,env/* getEnv */.dU)("LANDING_BUILDER_ENV"),
                    terminalCode: terminal,
                    terminalId: terminalId,
                    locationCode: location,
                    mappingDynamicSlots,
                    globalData: {
                        menu,
                        websiteId
                    }
                },
                rootId: "FOOTER",
                addGlobalStyle: !(layoutConfig === null || layoutConfig === void 0 ? void 0 : layoutConfig.header)
            })
        ]
    });
};
const Wrapper = emotion_styled_browser_esm["default"].div(_templateObject());


/***/ }),

/***/ 137697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ PbService; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-ecom-elements-virtual-94e4071fbd/0/cache/@tempi-ecom-elements-npm-1.0.84-1c112f128e-a6b1f8bb49.zip/node_modules/@tempi/ecom-elements/dist/constants/dynamic-block.js
var dynamic_block = __webpack_require__(102727);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@tempi-ecom-elements-virtual-94e4071fbd/0/cache/@tempi-ecom-elements-npm-1.0.84-1c112f128e-a6b1f8bb49.zip/node_modules/@tempi/ecom-elements/dist/utils/getSlotData.js
var getSlotData = __webpack_require__(746358);
// EXTERNAL MODULE: ./helpers/env.ts
var helpers_env = __webpack_require__(353632);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(788813);
;// CONCATENATED MODULE: ./modules/page-builder/helper.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
/**
 * remove a key from content
 * a key can have one or more children
 * so we need to remove the key and all its children
 *
 * write a recursive function to remove the key and its children
 *
 * @param key
 * @param content
 */ const removeComponentByKey = (key, content)=>{
    let newContent = _objectSpread({}, content);
    if (!newContent[key]) {
        return newContent;
    }
    if (newContent[key].children) {
        newContent[key].children.forEach((child)=>{
            newContent = removeComponentByKey(child, newContent);
        });
    }
    delete newContent[key];
    return newContent;
};
/**
 * get all config from content with a given id
 * a component can have one or more children
 * so we need to get the component and all its children
 *
 * write a recursive function to get the component and its children
 *
 * @param id
 * @param content
 */ const getContentById = function(id) {
    let content = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let result = {};
    if (content[id]) {
        var ref, ref1;
        result = _objectSpread({
            [id]: content[id]
        }, _objectSpread({}, (ref = content[id]) === null || ref === void 0 ? void 0 : (ref1 = ref.children) === null || ref1 === void 0 ? void 0 : ref1.reduce((acc, child)=>{
            return _objectSpread({}, acc, getContentById(child, content));
        }, {})));
    }
    return result;
};

;// CONCATENATED MODULE: ./modules/page-builder/service.ts
function service_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function service_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            service_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




class PbService {
    async getBuilder() {
        if (!this.builder) {
            this.builder = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 283958)).then((f)=>f.builder).then((builder)=>{
                builder.init(this.domain, service_objectSpread({}, this.configs));
                return builder;
            });
        }
        return this.builder;
    }
    async getPublicPageV2() {
        let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", device = arguments.length > 1 ? arguments[1] : void 0, terminalId = arguments.length > 2 ? arguments[2] : void 0;
        const builder = await this.getBuilder();
        return builder.getPublicPageV2({
            slug: page,
            device,
            appliedDomain: this.appliedDomain,
            terminalId
        });
    }
    async getSSRInputs(content, device) {
        const builder = await this.getBuilder();
        return builder.getSSRInputs(// I'm not so sure about this assertion :(
        content, {
            device,
            ssrComponentTags: dynamic_block.SSR_COMPONENT_TAGS,
            getSlotDataFunc: getSlotData/* getSlotData */.P
        });
    }
    /**
   * only return content config, exclude header, footer
   * @returns
   * @param page
   * @param device
   */ async getContentPage(page, device, terminalId) {
        const res = await this.getPublicPageV2(page, device, terminalId);
        let content = service_objectSpread({}, res.content);
        content = removeComponentByKey("FOOTER", removeComponentByKey("HEADER", content));
        //  remove key Header and footer in root content
        content["ROOT"].children = content["ROOT"].children.filter((id)=>id !== "HEADER" && id !== "FOOTER");
        return _objectSpreadProps(service_objectSpread({}, res), {
            content
        });
    }
    /**
   * only return layout config
   * include header, footer, root and its children
   */ async getLayoutPage(device) {
        const _ref = await this.getPublicPageV2("404", device), { content  } = _ref, res = _objectWithoutProperties(_ref, [
            "content"
        ]);
        return _objectSpreadProps(service_objectSpread({}, res), {
            layoutConfig: {
                header: getContentById("HEADER", content),
                footer: getContentById("FOOTER", content)
            }
        });
    }
    constructor(host, appliedDomain, isEpicEcom480){
        const env = (0,helpers_env/* getEnv */.dU)("LANDING_BUILDER_ENV") || "dev";
        this.domain = isEpicEcom480 ? host : (0,helpers/* getLocalDomain */.Hw)(host, env);
        const epicEcom480Phase2 = (0,helpers_env/* getEnv */.dU)("EPIC_ECOM_480_PHASE_2") === "enabled";
        if (epicEcom480Phase2) {
            this.appliedDomain = (0,helpers/* getLocalDomain */.Hw)(appliedDomain, env);
        }
        this.configs = {
            env: (0,helpers/* isServerless */.ep)() ? env : "internal"
        };
    }
}


/***/ }),

/***/ 164821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ mappingDynamicDesktopSlots; },
/* harmony export */   "Q": function() { return /* binding */ mappingDynamicMobileSlots; }
/* harmony export */ });
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_0__);

const ProductGridDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(44698), __webpack_require__.e(92117)]).then(__webpack_require__.bind(__webpack_require__, 98643)).then((f)=>f.ProductGridSlot.desktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98643)
            ]
    }
});
const ProductGridMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(44698), __webpack_require__.e(92117)]).then(__webpack_require__.bind(__webpack_require__, 98643)).then((f)=>f.ProductGridSlot.mobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(98643)
            ]
    }
});
const ProductCarouselSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(44698), __webpack_require__.e(74423)]).then(__webpack_require__.bind(__webpack_require__, 82041)).then((f)=>f.LazyProductCarouselSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(82041)
            ]
    }
});
const HamperCarouselSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(18204), __webpack_require__.e(44698), __webpack_require__.e(67810)]).then(__webpack_require__.bind(__webpack_require__, 867810)).then((f)=>f.LazyHamperCarouselSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(867810)
            ]
    }
});
const NewLayoutProductCarouselSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(44698), __webpack_require__.e(74423)]).then(__webpack_require__.bind(__webpack_require__, 82041)).then((f)=>f.LazyNewLayoutProductCarouselSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(82041)
            ]
    }
});
const PendingPaymentSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(4545), __webpack_require__.e(10433), __webpack_require__.e(7325), __webpack_require__.e(91141)]).then(__webpack_require__.bind(__webpack_require__, 512588)).then((f)=>f.PendingPaymentSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(512588)
            ]
    }
});
const RecentProductMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(11103), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(31038)]).then(__webpack_require__.bind(__webpack_require__, 770463)).then((f)=>f.LazyRecentProductMobileSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(770463)
            ]
    }
});
const RecentProductDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(29078), __webpack_require__.e(11103), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(31038)]).then(__webpack_require__.bind(__webpack_require__, 770463)).then((f)=>f.LazyRecentProductDesktopSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(770463)
            ]
    }
});
const RecentSearchSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>__webpack_require__.e(/* import() */ 40403).then(__webpack_require__.bind(__webpack_require__, 840403)).then((f)=>f.LazyRecentSearchSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(840403)
            ]
    }
});
const HeaderSearchDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(60367), __webpack_require__.e(29570)]).then(__webpack_require__.bind(__webpack_require__, 768493)).then((f)=>f.HeaderSearchSlot.desktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(768493)
            ]
    }
});
const HeaderSearchMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(60367), __webpack_require__.e(29570)]).then(__webpack_require__.bind(__webpack_require__, 768493)).then((f)=>f.HeaderSearchSlot.mobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(768493)
            ]
    }
});
const HeaderRightItemDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(16508), __webpack_require__.e(60367), __webpack_require__.e(8916), __webpack_require__.e(1208), __webpack_require__.e(43878)]).then(__webpack_require__.bind(__webpack_require__, 265987)).then((f)=>f.HeaderRightItemSlot.desktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(265987)
            ]
    }
});
const HeaderRightItemMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(10433), __webpack_require__.e(61431), __webpack_require__.e(16508), __webpack_require__.e(60367), __webpack_require__.e(8916), __webpack_require__.e(1208), __webpack_require__.e(43878)]).then(__webpack_require__.bind(__webpack_require__, 265987)).then((f)=>f.HeaderRightItemSlot.mobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(265987)
            ]
    }
});
const SearchBarRightItemsMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(60367), __webpack_require__.e(29570)]).then(__webpack_require__.bind(__webpack_require__, 768493)).then((f)=>f.SearchBarRightItemsMobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(768493)
            ]
    }
});
const LocationPickerHeaderMobile = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>__webpack_require__.e(/* import() */ 73212).then(__webpack_require__.bind(__webpack_require__, 673212)).then((f)=>f.LocationPickerHeaderMobile), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(673212)
            ]
    }
});
const BuildPCPickerDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(47351), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(60687), __webpack_require__.e(76698), __webpack_require__.e(57616), __webpack_require__.e(39486), __webpack_require__.e(23540), __webpack_require__.e(18204), __webpack_require__.e(30145), __webpack_require__.e(39706), __webpack_require__.e(18900)]).then(__webpack_require__.bind(__webpack_require__, 968887)).then((f)=>f.BuildPCPickerDesktopSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(968887)
            ]
    }
});
const BuildPCPickerMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(47351), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(60687), __webpack_require__.e(76698), __webpack_require__.e(57616), __webpack_require__.e(39486), __webpack_require__.e(23540), __webpack_require__.e(18204), __webpack_require__.e(30145), __webpack_require__.e(39706), __webpack_require__.e(18900)]).then(__webpack_require__.bind(__webpack_require__, 968887)).then((f)=>f.BuildPCPickerMobileSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(968887)
            ]
    }
});
const CustomHamperDesktopSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(47351), __webpack_require__.e(97691), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(60687), __webpack_require__.e(76698), __webpack_require__.e(39486), __webpack_require__.e(23540), __webpack_require__.e(18204), __webpack_require__.e(30145), __webpack_require__.e(39706), __webpack_require__.e(92239), __webpack_require__.e(29091)]).then(__webpack_require__.bind(__webpack_require__, 846777)).then((f)=>f.CustomHamperDesktopSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(846777)
            ]
    }
});
const CustomHamperMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(91592), __webpack_require__.e(71303), __webpack_require__.e(47351), __webpack_require__.e(97691), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(60687), __webpack_require__.e(76698), __webpack_require__.e(39486), __webpack_require__.e(23540), __webpack_require__.e(18204), __webpack_require__.e(30145), __webpack_require__.e(39706), __webpack_require__.e(92239), __webpack_require__.e(29091)]).then(__webpack_require__.bind(__webpack_require__, 846777)).then((f)=>f.CustomHamperMobileSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(846777)
            ]
    }
});
const LeftBannerProductMobileSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(29078), __webpack_require__.e(47728), __webpack_require__.e(88837), __webpack_require__.e(22859), __webpack_require__.e(39486), __webpack_require__.e(44698), __webpack_require__.e(53399)]).then(__webpack_require__.bind(__webpack_require__, 937206)).then((f)=>f.LazyLeftBannerProductMobileSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(937206)
            ]
    }
});
const VideoPreviewCarouselSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(88837), __webpack_require__.e(39486), __webpack_require__.e(88667)]).then(__webpack_require__.bind(__webpack_require__, 813086)).then((f)=>f.LazyVideoPreviewCarousel), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(813086)
            ]
    }
});
const RecommendProductModalSlot = next_dynamic__WEBPACK_IMPORTED_MODULE_0___default()(()=>Promise.all(/* import() */[__webpack_require__.e(41305), __webpack_require__.e(90400), __webpack_require__.e(39840), __webpack_require__.e(88837), __webpack_require__.e(86914)]).then(__webpack_require__.bind(__webpack_require__, 686914)).then((f)=>f.RecommendProductModalSlot), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(686914)
            ]
    }
});
const mappingDynamicDesktopSlots = {
    product_grid_desktop: ProductGridDesktopSlot,
    product_carousel_desktop: ProductCarouselSlot,
    hamper_carousel_desktop: HamperCarouselSlot,
    recent_product: RecentProductDesktopSlot,
    header_search_desktop: HeaderSearchDesktopSlot,
    header_right_items_desktop: HeaderRightItemDesktopSlot,
    build_pc: BuildPCPickerDesktopSlot,
    new_layout_product_carousel_desktop: NewLayoutProductCarouselSlot,
    video_preview_carouse: VideoPreviewCarouselSlot,
    custom_hamper: CustomHamperDesktopSlot,
    modal_recommend_product: RecommendProductModalSlot
};
const mappingDynamicMobileSlots = {
    product_grid_mobile: ProductGridMobileSlot,
    product_carousel_mobile: ProductCarouselSlot,
    hamper_carousel_mobile: HamperCarouselSlot,
    pending_payment: PendingPaymentSlot,
    recent_product: RecentProductMobileSlot,
    recent_search: RecentSearchSlot,
    header_search_mobile: HeaderSearchMobileSlot,
    header_right_items_mobile: HeaderRightItemMobileSlot,
    search_bar_right_items_mobile: SearchBarRightItemsMobile,
    build_pc: BuildPCPickerMobileSlot,
    left_banner_product_mobile: LeftBannerProductMobileSlot,
    location_picker_header_mobile: LocationPickerHeaderMobile,
    new_layout_product_carousel_mobile: NewLayoutProductCarouselSlot,
    video_preview_carouse: VideoPreviewCarouselSlot,
    custom_hamper: CustomHamperMobileSlot,
    modal_recommend_product: RecommendProductModalSlot
};


/***/ }),

/***/ 353120:
/***/ (function() {

/* (ignored) */

/***/ })

}]);